import { Redirect } from "react-router-dom";

const NativeAppLogin = () => {
  return <Redirect to="/" />;
};

export default NativeAppLogin;
